<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="160px">
        <div class="filter-col">
          <el-form-item label="姓名：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码：">
            <el-input clearable v-model="filterForm.idCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="派遣单位名称：">
            <el-input clearable v-model="filterForm.o_name" placeholder="请输入派遣单位名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-popover placement="bottom" width="1500">
            <el-form class="section-filter1" :model="filterForm" :inline="true" label-width="170px">
              <div class="filter-col">
                <el-form-item label="养老保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startSocialInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="养老保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endSocialInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="养老保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startSocialInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="养老保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endSocialInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="养老保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startSocialInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="养老保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endSocialInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="失业保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startLostJobInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="失业保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endLostJobInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="失业保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startLostJobInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="失业保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endLostJobInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="失业保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startLostJobInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="失业保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endLostJobInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="医疗保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startMedicalInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="医疗保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endMedicalInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="医疗保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startMedicalInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="医疗保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endMedicalInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="医疗保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startMedicalInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="医疗保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endMedicalInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="生育保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBornInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="生育保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBornInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="生育保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBornInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="生育保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBornInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="生育保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBornInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="生育保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBornInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="工伤保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startInjuryOnJobInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="工伤保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endInjuryOnJobInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="工伤保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startInjuryOnJobInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="工伤保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endInjuryOnJobInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="工伤保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startInjuryOnJobInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="工伤保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endInjuryOnJobInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="商业保险参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBusinessInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="商业保险参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBusinessInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="商业保险报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBusinessInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="商业保险报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBusinessInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="商业保险停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startBusinessInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="商业保险停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endBusinessInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
              <div class="filter-col">
                <el-form-item label="公积金参保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startHouseFundInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="公积金参保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endHouseFundInsuranceStartMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="公积金报送起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startHouseFundInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="公积金报送截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endHouseFundInsuranceSendMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="公积金停保起始时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.startHouseFundInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="公积金停保截止时间：">
                  <el-date-picker
                    size="mini" type="datetime" v-model="filterForm.endHouseFundInsuranceEndMillisecond" :style="'width:200px;'"
                    format="yyyy-MM-dd" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                </el-form-item>
              </div>
            </el-form>
            <el-button slot="reference" icon="el-icon-search" style="margin:0 10px;">更多查询</el-button>
          </el-popover>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2"
      labelWidth="240px" /><!-- dialogWidth="1000px" -->

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler"
      :isShowArea="true" />
      <!-- @watchChange="watchChange"
      dialogWidth="1000px" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" />
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'shebao_geren',
      dialogTitle: '个人社保信息',
      // fileName: 'qiyexinxi',
      xlsCode: '50',
      importTipKey: 'idCard',
      importTiplabel: '身份证号码',

      baseInfo: [
        { key: 'province', label: '省', fixed: true },
        { key: 'city', label: '市', fixed: true },
        { key: 'county', label: '县', fixed: true },
        { key: 'town', label: '镇', fixed: true },
        { key: 'village', label: '村', fixed: true },
        // { key: 'areaName', label: '地区', fixed: true },

        { key: 'name', label: '姓名', fixed: true },
        { key: 'idCard', label: '身份证号码', fixed: true },
        { key: 'sex', label: '性别' },
        { key: 'nation', label: '民族' },
        { key: 'personType', label: '个人身份' },
        { key: 'jobType', label: '用工形式' },
        { key: 'education', label: '文化程度' },
        { key: 'marriage', label: '婚姻状况' },
        { key: 'bornDate', label: '档案出生日期' },
        { key: 'army', label: '是否曾在部队服役' },
        { key: 'o_name', label: '派遣单位名称' },
        { key: 'o_number', label: '派遣到该单位次数' },
        // { key: 'socialInsuranceStartDate', label: '养老保险参保日期' },
        // { key: 'socialInsuranceSendDate', label: '养老保险报送日期' },
        // { key: 'socialInsuranceEndDate', label: '养老保险停保日期' },
        // { key: 'socialPersonBase', label: '养老保险缴费基数' },
        // { key: 'socialPersonPercent', label: '养老保险个人缴费比例' },
        // { key: 'socialOrganizationPercent', label: '养老保险单位缴费比例' },
        // { key: 'lostJobInsuranceStartDate', label: '失业保险参保日期' },
        // { key: 'lostJobInsuranceSendDate', label: '失业保险报送日期' },
        // { key: 'lostJobInsuranceEndDate', label: '失业保险停保日期' },
        // { key: 'lostJobPersonBase', label: '失业保险缴费基数' },
        // { key: 'lostJobPersonPercent', label: '失业保险个人缴费比例' },
        // { key: 'lostJobOrganizationPercent', label: '失业保险单位缴费比例' },
        // { key: 'medicalInsuranceStartDate', label: '医疗保险参保日期' },
        // { key: 'medicalInsuranceSendDate', label: '医疗保险报送日期' },
        // { key: 'medicalInsuranceEndDate', label: '医疗保险停保日期' },
        // { key: 'medicalBase', label: '医疗保险缴费基数' },
        // { key: 'medicalPersonPercent', label: '医疗保险个人缴费比例' },
        // { key: 'medicalOrganizationPercent', label: '医疗保险单位缴费比例' },
        // { key: 'bornInsuranceStartDate', label: '生育保险参保日期' },
        // { key: 'bornInsuranceSendDate', label: '生育保险报送日期' },
        // { key: 'bornInsuranceEndDate', label: '生育保险停保日期' },
        // { key: 'bornBase', label: '生育保险缴费基数' },
        // { key: 'bornPersonPercent', label: '生育保险个人缴费比例' },
        // { key: 'bornOrganizationPercent', label: '生育保险单位缴费比例' },
        // { key: 'injuryOnJobStartDate', label: '工伤保险参保日期' },
        // { key: 'injuryOnJobSendDate', label: '工伤保险报送日期' },
        // { key: 'injuryOnJobEndDate', label: '工伤保险停保日期' },
        // { key: 'injuryBase', label: '工伤保险缴费基数' },
        // { key: 'injuryPersonPercent', label: '工伤保险个人缴费比例' },
        // { key: 'injuryOrganizationPercent', label: '工伤保险单位缴费比例' },
        // { key: 'businessInsuranceStartDate', label: '商业保险参保日期' },
        // { key: 'businessInsuranceSendDate', label: '商业保险报送日期' },
        // { key: 'businessInsuranceEndDate', label: '商业保险停保日期' },
        // { key: 'businessBase', label: '商业保险缴费基数' },
        // { key: 'businessPersonPercent', label: '商业保险个人缴费比例' },
        // { key: 'businessOrganizationPercent', label: '商业保险单位缴费比例' },
        // { key: 'houseFundStartDate', label: '住房公积金参保日期' },
        // { key: 'houseFundSendDate', label: '住房公积金报送日期' },
        // { key: 'houseFundEndDate', label: '住房公积金停保日期' },
        // { key: 'houseFundBase', label: '住房公积金缴费基数' },
        // { key: 'houseFundPersonPercent', label: '住房公积金个人缴费比例' },
        // { key: 'houseFundOrganizationPercent', label: '住房公积金单位缴费比例' },
        // { key: 'residenceType', label: '户口性质' },
        // { key: 'residenceAddress', label: '户口所在地' },
        // { key: 'address', label: '常住地址' },
        // { key: 'zipCode', label: '邮政编码' },
        // { key: 'phone', label: '联系电话' },
        // { key: 'personBase', label: '缴费基数' },
        // { key: 'reason', label: '参保原因' },
        // { key: 'organizationNo', label: '分支机构编号(非必填项)' },
        // { key: 'marks', label: '农民工标识' },
        // { key: 'giftCash', label: '生日礼金' },
        // { key: 'startDate', label: '开始工作日期' },
        // { key: 'endDate', label: '停止工作日期' },
        // { key: 'department', label: '所在部门' },
        // { key: 'jobTitle', label: '岗位/职务' },
        // { key: 'contractType', label: '合同类型' },
        // { key: 'contractPeriod', label: '合同期限' },
        // { key: 'archiveTransfer', label: '档案是否移交' },
        // { key: 'transferDate', label: '移交时间' },
        // { key: 'description', label: '备注信息' },
      ],
      watchChangeKey: [
        // 'buyType'
      ],
      defaultKeyValue: {
        // buyType: 1
      },
      // userList: [],
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
      return this.$api.baseUrl + this.$api.url_import(this.sign)
    },
    formItems() {
      return [
        { type: 'text', key: 'name', label: '姓名' },
        { type: 'text', key: 'idCard', label: '身份证号码' },
        { type: 'select_s', key: 'sex', label: '性别', options: ['男', '女'] },
        { type: 'text', key: 'nation', label: '民族' },
        { type: 'select_s', key: 'personType', label: '个人身份', options: ['1-工人','4-干部','30-自由职业者'] },
        { type: 'select_s', key: 'jobType', label: '用工形式', options: ['1-原固定职工','2-城镇合同制职工','3-农民合同制工人','4-临时工','9-其它'] },
        { type: 'select_s', key: 'education', label: '文化程度', options: ['0-无','11-博士','12-硕士','21-大学','31-大专','40-中专','50-技校','61-高中','62-职高','70-初中','80-小学','90-文盲'] },
        { type: 'select_s', key: 'marriage', label: '婚姻状况', options: ['1-未婚','2-已婚','3-丧偶','4-离婚','9-其他'] },
        { type: 'text', key: 'bornDate', label: '档案出生日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'select_s', key: 'army', label: '是否曾在部队服役', options: ['0-否','1-是'] },
        { type: 'text', key: 'o_name', label: '派遣单位名称' },
        { type: 'text', key: 'o_number', label: '派遣到该单位次数' },

        { type: 'text', key: 'socialInsuranceStartDate', label: '养老保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'socialInsuranceSendDate', label: '养老保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'socialInsuranceEndDate', label: '养老保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'socialPersonBase', label: '养老保险缴费基数' },
        { type: 'text', key: 'socialPersonPercent', label: '养老保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'socialOrganizationPercent', label: '养老保险单位缴费比例', placeholder: '格式为0-1小数' },

        { type: 'text', key: 'lostJobInsuranceStartDate', label: '失业保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'lostJobInsuranceSendDate', label: '失业保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'lostJobInsuranceEndDate', label: '失业保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'lostJobPersonBase', label: '失业保险缴费基数' },
        { type: 'text', key: 'lostJobPersonPercent', label: '失业保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'lostJobOrganizationPercent', label: '失业保险单位缴费比例', placeholder: '格式为0-1小数' },

        { type: 'text', key: 'medicalInsuranceStartDate', label: '医疗保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'medicalInsuranceSendDate', label: '医疗保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'medicalInsuranceEndDate', label: '医疗保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'medicalBase', label: '医疗保险缴费基数' },
        { type: 'text', key: 'medicalPersonPercent', label: '医疗保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'medicalOrganizationPercent', label: '医疗保险单位缴费比例', placeholder: '格式为0-1小数' },
        
        { type: 'text', key: 'bornInsuranceStartDate', label: '生育保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'bornInsuranceSendDate', label: '生育保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'bornInsuranceEndDate', label: '生育保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'bornBase', label: '生育保险缴费基数' },
        { type: 'text', key: 'bornPersonPercent', label: '生育保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'bornOrganizationPercent', label: '生育保险单位缴费比例', placeholder: '格式为0-1小数' },
      ]
    },
    formItems2() {
      return [

        { type: 'text', key: 'injuryOnJobStartDate', label: '工伤保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'injuryOnJobSendDate', label: '工伤保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'injuryOnJobEndDate', label: '工伤保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'injuryBase', label: '工伤保险缴费基数' },
        { type: 'text', key: 'injuryPersonPercent', label: '工伤保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'injuryOrganizationPercent', label: '工伤保险单位缴费比例', placeholder: '格式为0-1小数' },

        { type: 'text', key: 'businessInsuranceStartDate', label: '商业保险参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'businessInsuranceSendDate', label: '商业保险报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'businessInsuranceEndDate', label: '商业保险停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'businessBase', label: '商业保险缴费基数' },
        { type: 'text', key: 'businessPersonPercent', label: '商业保险个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'businessOrganizationPercent', label: '商业保险单位缴费比例', placeholder: '格式为0-1小数' },
        
        { type: 'text', key: 'houseFundStartDate', label: '公积金参保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'houseFundSendDate', label: '公积金报送日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'houseFundEndDate', label: '公积金停保日期', placeholder: '格式为yyyymmdd，8位数字' },
        { type: 'text', key: 'houseFundBase', label: '住房公积金缴费基数' },
        { type: 'text', key: 'houseFundPersonPercent', label: '住房公积金个人缴费比例', placeholder: '格式为0-1小数' },
        { type: 'text', key: 'houseFundOrganizationPercent', label: '住房公积金单位缴费比例', placeholder: '格式为0-1小数' },
        { type: 'select_s', key: 'residenceType', label: '户口性质', options: ['1-城镇(非农业户口)','2-农村(农业户口)','3-外地城镇户口','4-外地非城镇户口','5-待定'] },
        { type: 'text', key: 'residenceAddress', label: '户口所在地' },
        { type: 'text', key: 'address', label: '常住地址' },
        { type: 'text', key: 'zipCode', label: '邮政编码' },
        { type: 'text', key: 'phone', label: '联系电话' },
        // { type: 'text', key: 'personBase', label: '缴费基数' },
        { type: 'text', key: 'reason', label: '参保原因' },
        { type: 'text', key: 'organizationNo', label: '分支机构编号(非必填项)' },
        { type: 'text', key: 'marks', label: '农民工标识' },
        { type: 'text', key: 'giftCash', label: '生日礼金' },
        { type: 'text', key: 'startDate', label: '开始工作日期' },
        { type: 'text', key: 'endDate', label: '停止工作日期' },
        { type: 'text', key: 'department', label: '所在部门' },
        { type: 'text', key: 'jobTitle', label: '岗位/职务' },
        { type: 'text', key: 'contractType', label: '合同类型' },
        { type: 'text', key: 'contractPeriod', label: '合同期限' },
        { type: 'text', key: 'archiveTransfer', label: '档案是否移交' },
        { type: 'text', key: 'transferDate', label: '移交时间' },
        { type: 'text', key: 'description', label: '备注信息' },
      ]
    }
  },
  methods: {
    searchHandlerBefore(areaId) {
      this.$route.query.id ? this.filterForm.idCard = this.$route.query.id : ''
    },
    // modifyHandlerBefore() {
      //   let {
      //     user
      //   } = this.selectData
      //   console.log(user.u_idCard)
      //   this.userList = [
      //     {
      //       label: user.u_idCard,
      //       value: user.id,
      //     }
      //   ]
      // },
    // watchChange(data) {
      //   console.log(`%caaaa:`, 'color: #f00;', data)
      //   switch (data.key) {
      //     case 'buyType':
      //       if (data.val === 1) {
      //         this.formItems.splice(8, 1)
      //       } else if (data.val === 2) {
      //         this.formItems.splice(8, 1, { type: 'text', key: 'cash', label: '垫付金额' })
      //       }
      //       break;
      //   }
      // },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        id, province, city, county, town, village, 
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        name,
        idCard,
        sex,
        nation,
        personType,
        jobType,
        education,
        marriage,
        bornDate,
        army,
        o_name,
        o_number,
        socialInsuranceStartDate,
        socialInsuranceSendDate,
        socialInsuranceEndDate,
        socialPersonBase,
        socialPersonPercent,
        socialOrganizationPercent,
        lostJobInsuranceStartDate,
        lostJobInsuranceSendDate,
        lostJobInsuranceEndDate,
        lostJobPersonBase,
        lostJobPersonPercent,
        lostJobOrganizationPercent,
        medicalInsuranceStartDate,
        medicalInsuranceSendDate,
        medicalInsuranceEndDate,
        medicalBase,
        medicalPersonPercent,
        medicalOrganizationPercent,
        bornInsuranceStartDate,
        bornInsuranceSendDate,
        bornInsuranceEndDate,
        bornBase,
        bornPersonPercent,
        bornOrganizationPercent,
        injuryOnJobStartDate,
        injuryOnJobSendDate,
        injuryOnJobEndDate,
        injuryBase,
        injuryPersonPercent,
        injuryOrganizationPercent,
        businessInsuranceStartDate,
        businessInsuranceSendDate,
        businessInsuranceEndDate,
        businessBase,
        businessPersonPercent,
        businessOrganizationPercent,
        houseFundStartDate,
        houseFundSendDate,
        houseFundEndDate,
        houseFundBase,
        houseFundPersonPercent,
        houseFundOrganizationPercent,
        residenceType,
        residenceAddress,
        address,
        zipCode,
        phone,
        personBase,
        reason,
        organizationNo,
        marks,
        giftCash,
        startDate,
        endDate,
        department,
        jobTitle,
        contractType,
        contractPeriod,
        archiveTransfer,
        transferDate,
        description,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      const timeMap = {
        'bornDate': '档案出生日期',
        'socialInsuranceStartDate': '养老保险参保日期',
        'socialInsuranceSendDate': '养老保险报送日期',
        'socialInsuranceEndDate': '养老保险停保日期',
        'lostJobInsuranceStartDate': '失业保险参保日期',
        'lostJobInsuranceSendDate': '失业保险报送日期',
        'lostJobInsuranceEndDate': '失业保险停保日期',
        'medicalInsuranceStartDate': '医疗保险参保日期',
        'medicalInsuranceSendDate': '医疗保险报送日期',
        'medicalInsuranceEndDate': '医疗保险停保日期',
        'bornInsuranceStartDate': '生育保险参保日期',
        'bornInsuranceSendDate': '生育保险报送日期',
        'bornInsuranceEndDate': '生育保险停保日期',
        'injuryOnJobStartDate': '工伤保险参保日期',
        'injuryOnJobSendDate': '工伤保险报送日期',
        'injuryOnJobEndDate': '工伤保险停保日期',
        'businessInsuranceStartDate': '商业保险参保日期',
        'businessInsuranceSendDate': '商业保险报送日期',
        'businessInsuranceEndDate': '商业保险停保日期',
        'houseFundStartDate': '住房公积金参保日期',
        'houseFundSendDate': '住房公积金报送日期',
        'houseFundEndDate': '住房公积金停保日期',
        'startDate': '开始工作日期',
        'endDate': '停止工作日期',
        'transferDate': '移交时间',
      }
      let status = true
      let item = ''
      Object.keys(timeMap).forEach(x => {
        if (status) {
          if (result[x] && !/^[0-9]{8}$/.test(result[x])) {
            status = false
            item = timeMap[x]
          }
        }
      })
      const numMap = {
        'socialPersonPercent': '养老保险个人缴费比例',
        'socialOrganizationPercent': '养老保险单位缴费比例',
        'lostJobPersonPercent': '失业保险个人缴费比例',
        'lostJobOrganizationPercent': '失业保险单位缴费比例',
        'medicalPersonPercent': '医疗保险个人缴费比例',
        'medicalOrganizationPercent': '医疗保险单位缴费比例',
        'bornPersonPercent': '生育保险个人缴费比例',
        'bornOrganizationPercent': '生育保险单位缴费比例',
        'injuryPersonPercent': '工伤保险个人缴费比例',
        'injuryOrganizationPercent': '工伤保险单位缴费比例',
        'businessPersonPercent': '商业保险个人缴费比例',
        'businessOrganizationPercent': '商业保险单位缴费比例',
        'houseFundPersonPercent': '住房公积金个人缴费比例',
        'houseFundOrganizationPercent': '住房公积金单位缴费比例',
      }
      Object.keys(numMap).forEach(x => {
        if (status) {
          if (result[x] && !/^[0-1]$|^0\.[0-9]+$/.test(result[x])) {
            status = false
            item = numMap[x]
          }
        }
      })

      if (!province) { this.$message.warning('请选择地区') }
      else if (!name) { this.$message.warning('请填写姓名') }
      else if (!idCard) { this.$message.warning('请填写身份证号码') }
      else if (!o_number) { this.$message.warning('派遣到该单位次数') }
      else if (!status) { this.$message.warning('请正确填写'+item+'的数据格式') }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      else if (this.isCreate) {
        rData = {
          province, city, county, town, village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          name,
          idCard,
          sex,
          nation,
          personType,
          jobType,
          education,
          marriage,
          bornDate,
          army,
          o_name,
          o_number,
          socialInsuranceStartDate,
          socialInsuranceSendDate,
          socialInsuranceEndDate,
          socialPersonBase,
          socialPersonPercent,
          socialOrganizationPercent,
          lostJobInsuranceStartDate,
          lostJobInsuranceSendDate,
          lostJobInsuranceEndDate,
          lostJobPersonBase,
          lostJobPersonPercent,
          lostJobOrganizationPercent,
          medicalInsuranceStartDate,
          medicalInsuranceSendDate,
          medicalInsuranceEndDate,
          medicalBase,
          medicalPersonPercent,
          medicalOrganizationPercent,
          bornInsuranceStartDate,
          bornInsuranceSendDate,
          bornInsuranceEndDate,
          bornBase,
          bornPersonPercent,
          bornOrganizationPercent,
          injuryOnJobStartDate,
          injuryOnJobSendDate,
          injuryOnJobEndDate,
          injuryBase,
          injuryPersonPercent,
          injuryOrganizationPercent,
          businessInsuranceStartDate,
          businessInsuranceSendDate,
          businessInsuranceEndDate,
          businessBase,
          businessPersonPercent,
          businessOrganizationPercent,
          houseFundStartDate,
          houseFundSendDate,
          houseFundEndDate,
          houseFundBase,
          houseFundPersonPercent,
          houseFundOrganizationPercent,
          residenceType,
          residenceAddress,
          address,
          zipCode,
          phone,
          personBase,
          reason,
          organizationNo,
          marks,
          giftCash,
          startDate,
          endDate,
          department,
          jobTitle,
          contractType,
          contractPeriod,
          archiveTransfer,
          transferDate,
          description,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList_must = ['province', 'city', 'county', 'town', 'village']
        mapList_must.forEach(x => {
          rData[x] = result[x]
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList = [
          'name',
          'idCard',
          'sex',
          'nation',
          'personType',
          'jobType',
          'education',
          'marriage',
          'bornDate',
          'army',
          'o_name',
          'o_number',
          'socialInsuranceStartDate',
          'socialInsuranceSendDate',
          'socialInsuranceEndDate',
          'socialPersonBase',
          'socialPersonPercent',
          'socialOrganizationPercent',
          'lostJobInsuranceStartDate',
          'lostJobInsuranceSendDate',
          'lostJobInsuranceEndDate',
          'lostJobPersonBase',
          'lostJobPersonPercent',
          'lostJobOrganizationPercent',
          'medicalInsuranceStartDate',
          'medicalInsuranceSendDate',
          'medicalInsuranceEndDate',
          'medicalBase',
          'medicalPersonPercent',
          'medicalOrganizationPercent',
          'bornInsuranceStartDate',
          'bornInsuranceSendDate',
          'bornInsuranceEndDate',
          'bornBase',
          'bornPersonPercent',
          'bornOrganizationPercent',
          'injuryOnJobStartDate',
          'injuryOnJobSendDate',
          'injuryOnJobEndDate',
          'injuryBase',
          'injuryPersonPercent',
          'injuryOrganizationPercent',
          'businessInsuranceStartDate',
          'businessInsuranceSendDate',
          'businessInsuranceEndDate',
          'businessBase',
          'businessPersonPercent',
          'businessOrganizationPercent',
          'houseFundStartDate',
          'houseFundSendDate',
          'houseFundEndDate',
          'houseFundBase',
          'houseFundPersonPercent',
          'houseFundOrganizationPercent',
          'residenceType',
          'residenceAddress',
          'address',
          'zipCode',
          'phone',
          'personBase',
          'reason',
          'organizationNo',
          'marks',
          'giftCash',
          'startDate',
          'endDate',
          'department',
          'jobTitle',
          'contractType',
          'contractPeriod',
          'archiveTransfer',
          'transferDate',
          'description',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        // rData.userId = this.selectData.userId
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            return x
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        } else if (!x) {
          this.btnShow.search = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.section-filter1{display: flex;padding: 20px;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;width: 100px;text-align: right;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>